// V4.12 Phase E — Saved Searches / Alerts API client.
import { apiClient } from "./client";

export async function listSavedSearches() {
  const r = await apiClient.get("/saved-searches");
  return r.data;
}

export async function createSavedSearch(payload) {
  const r = await apiClient.post("/saved-searches", payload);
  return r.data;
}

export async function previewSavedSearch(payload) {
  const r = await apiClient.post("/saved-searches/preview", payload);
  return r.data;
}

export async function patchSavedSearch(ulid, payload) {
  const r = await apiClient.patch(`/saved-searches/${ulid}`, payload);
  return r.data;
}

export async function deleteSavedSearch(ulid) {
  const r = await apiClient.delete(`/saved-searches/${ulid}`);
  return r.data;
}

export async function runSavedSearch(ulid) {
  const r = await apiClient.post(`/saved-searches/${ulid}/run`);
  return r.data;
}

// Canonical filters → /heatmap URL params (same vocabulary everywhere).
export function filtersToMapParams(vertical, filters) {
  const p = { v: vertical === "auto" ? "auto" : "immo" };
  ["makes", "models", "fuels", "gearboxes", "body_types", "features", "seller_types"].forEach(
    (k) => {
      if (Array.isArray(filters?.[k]) && filters[k].length) {
        p[k] = filters[k].join(",");
      }
    },
  );
  if (Array.isArray(filters?.object_types) && filters.object_types.length) {
    p.types = filters.object_types.join(",");
  }
  ["year_min", "year_max", "km_max", "price_min", "price_max", "rooms_min",
    "area_min", "area_max", "yield_min"].forEach((k) => {
    if (filters?.[k] !== null && filters?.[k] !== undefined && filters?.[k] !== "") {
      p[k] = filters[k];
    }
  });
  if (filters?.transaction_type) p.tt = filters.transaction_type;
  // V4.23 Phase 3a — place + country scope survive the map deep-link so
  // "show all on map" reproduces exactly the alert's result set.
  if (filters?.region) p.region = filters.region;
  if (filters?.country) p.country = filters.country;
  return p;
}
